import React from 'react'

import './Lost.css'
import floatingAstronaut from './../images/floatingAstronaut.png'

class Lost extends React.Component {
  componentDidMount() {
    document.title = "Sheed | Error 404"
  }

  render() {
    return (
      <div className='glide'>
        <img src={floatingAstronaut} alt="Floating Astronaut" className="astronaut" />
        <div className="displayMsg">
          It seems you're lost, Little Spaceman.
        </div>
      </div>
    )
  }
}

export default Lost